export const appHalfCircleIcon = {
  data: `<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="7" cy="7" r="6.5" fill="white" stroke="currentColor"/>
    <path d="M7 2C6.34339 2 5.69321 2.12933 5.08658 2.3806C4.47995 2.63188 3.92876 3.00017 3.46447 3.46447C3.00017 3.92876 2.63188 4.47995 2.3806 5.08658C2.12933 5.69321 2 6.34339 2 7C2 7.65661 2.12933 8.30679 2.3806 8.91342C2.63188 9.52005 3.00017 10.0712 3.46447 10.5355C3.92876 10.9998 4.47996 11.3681 5.08658 11.6194C5.69321 11.8707 6.34339 12 7 12L7 7V2Z"
          fill="currentColor" fill-opacity="0.3"
    />
</svg>
`,
  name: 'half-circle',
};
